export default "__VITE_ASSET__CyrsPkqY__"